<template>
  <div class="program-list" v-if="data.length">
    <ProgramListHead v-model="data.length" />

    <div class="list">
      <div class="head" v-if="data.length">
        <div class="col program-name">
          {{ $ml.get(`Program Name`) }}
        </div>
        <div class="col farm-field-name">
          {{ $ml.get(`Farm/Field Name`) }}
        </div>
        <div class="col crop">
          {{ $ml.get(`Crop`) }}
        </div>
        <div class="col fert-method">
          {{ $ml.get(`TYPE`) }}
        </div>
        <div class="col start-date">
          {{ $ml.get(`PLANING START DATE`) }}
        </div>
        <div class="col actions" v-if="$store.getters['user/plan'] != 'impact'">
          {{ $ml.get(`Actions`) }}
        </div>
      </div>

      <app-loading :loading="loading" pos="100px">
        <template>
          <ProgramListItem
            @update="sync"
            v-for="program in data"
            :key="program.id"
            :program="program"
          />
        </template>
      </app-loading>

      <!-- <appPagination
        :start="Number(filters.page)"
        :length="Number(pageCount)"
        :link="'/dashboard/programs/list/{id}'"
        class="pagination"
      /> -->
    </div>
  </div>
  <app-loading :loading="loading" class="empty" v-else>
    <ProgramListHead v-model="data.length" />
  </app-loading>
</template>

<script>
import { ProgramAPI } from "@/api";
import AppPagination from "@/components/common/AppPagination";
import ProgramListItem from "@/components/program/ProgramListItem";
import ProgramListHead from "@/components/program/ProgramListHead";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      data: [],
      loading: false,
      pageCount: 0,
      filters: {
        page: 0,
        take: 100,
        type: null,
        search: null,
      },
    };
  },
  created() {
    this.sync();
  },
  methods: {
    //=================================================================================
    sync() {
      this.loading = true;
      return ProgramAPI.getPrograms(this.filters)

        .then((res) => {
          let result = JSON.parse(JSON.stringify(res));
          if (result.data.message == "Please buy a plan!") {
            this.$notify({
              group: "notices",
              title: this.$ml.get(
                `Please buy a plan before selecting programs.`
              ),
              type: "error",
            });
          } else {
            this.data = res.data.data;
            this.pageCount = res.data.pages;
          }
        })
        .catch((err) => {
          this.$notify({
            title: "Failed",
            text: err.response.statusText,
            type: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //=================================================================================

    toggleCreateProgramPopup() {
      this.openPopup ^= true;
    },

    deleteProgram(id) {
      this.$store.commit("modals/prompt/open", {
        onAccept: () => {
          return ProgramAPI.deleteProgram(id).then((res) => {
            this.sync();
          });
        },
        onCancel: () => {},
        text: this.$ml.get(`Are you sure?`),
      });
    },
  },
  components: {
    AppPagination,
    ProgramListItem,
    ProgramListHead,
  },
  computed: {},
  beforeRouteUpdate(to, from, next) {
    next();
    this.filters.page = this.$route.params.idList;
    this.sync();
  },
};
</script>

<style lang="scss" scoped>
.program-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;

  .head {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e4e5e6;
    user-select: none;

    .col {
      flex-grow: 2;
      flex-basis: 16%;
      padding: 8px;

      text-transform: uppercase;
      font-size: 12px;
      padding-bottom: 8px;
      margin-bottom: 8px;
      font-weight: 500;
      color: #8b8d91;
      &.program-name,
      &.farm-field-name {
        flex-basis: 26%;
      }
    }
  }

  .list {
    overflow: hidden;
    padding: 8px 12px;
    background-color: #fff;
    border-radius: 5px;
    flex-grow: 2;
    position: relative;
    border: 1px #e4e5e6 solid;

    // .pagination {
    //   position: absolute;
    //   bottom: 0;
    //   left: 0;
    // }
  }

  .no-data {
    color: rgb(211, 211, 211);
    font-weight: 500;
    font-size: 24px;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 768px) {
    // .list {
    //   .a-row {
    //     flex-direction: column;
    //     align-items: flex-start;
    //     &
    //     > * {
    //       margin-bottom: 4px;
    //       &.actions {
    //         display: none;
    //       }
    //     }
    //   }
    // }

    .head {
      display: none;
    }
  }
}
</style>
